import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ContactTypeResponse} from '../../../../_models/contact-type.model';
import {ContactTypeService} from '../../../../_services/contact-type-service';
import {GenericOption, Payload, PayloadMeta} from '@cas-hub/acabim-common-client';
import {Subscription} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'acabim-admin-remove-contact-type',
  templateUrl: './remove-contact-type.component.html',
  styleUrls: ['./remove-contact-type.component.scss']
})
export class RemoveContactTypeComponent implements OnInit, OnDestroy {

  preventMigration = false;
  archiveSuccess = false;
  archiveSuccessMessage = 'Success';
  contactTypeServiceSub: Subscription = new Subscription();
  details: ContactTypeResponse | null = null;
  existingContactCount = 0;
  existingContactCountMessage = 'There are no contacts associated with this contact type';
  existingContacts: Payload[] = [];
  isLoading = false;
  migrationContactTypes: GenericOption[] = [];
  migrationSuccess = false;
  migrationSuccessMessage = 'Success';
  next = 'next';
  step = 1;

  existingContactsMeta: PayloadMeta = {
        columns: [
            {columnNumber: 0, title: 'Id', width: '3rem'},
            {columnNumber: 1, title: 'Name'}
        ],
        showColumn: true
    };
  migrationForm: FormGroup = new FormGroup({
        targetContactType: new FormControl()
    });
  existingContactsAttr: {
        name1: string
    } = {name1: 'these contacts'};


  @Output() public completed = new EventEmitter<string>();
  @Input() public set contactTypeDetails(value: ContactTypeResponse) {
    this.details = value;
    this.isLoading = true;
    this.contactTypeServiceSub = this.contactTypeService.getContactTypeContacts(value.id).subscribe(
        ct => {
          this.existingContacts = ct.data.map(d => {return {value: [d.value], label: d.id.toString()}});
          this.existingContactCount = ct.data.length;
          if (this.existingContactCount === 1) {
            const contact = ct.data.pop();
            if(contact && contact.value) {
              this.existingContactCountMessage = `There is one contact associated with this contact type: ${contact.value}`;
              this.existingContactsAttr = {name1: 'this contact'}
            }
          } else if (this.existingContactCount > 1) {
            this.existingContactCountMessage = `There are ${this.existingContactCount} contacts associated with this contact type`;
          }
          if(this.existingContactCount > 0) {
              this.next = 'migrate';
              this.preventMigration = true;
              this.contactTypeService.getContactTypes().subscribe(d => {
                  if (d && d.data) {
                      d.data.map(ct => {
                          if (ct && ct.id !== value.id) {
                              this.migrationContactTypes.push({value: ct.id, label: ct.name})
                          }
                      });
                      this.migrationForm.get('targetContactType')?.valueChanges.subscribe(vc => {
                          if (vc > 0) {
                              this.preventMigration = false;
                          }
                      })
                  }
              });
          } else {
              this.next = 'complete';
              this.preventMigration = false;
          }
          this.isLoading = false;
        },
        error =>  { this.isLoading = false; }
    );
  }

  constructor(private contactTypeService: ContactTypeService) { }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.contactTypeServiceSub.unsubscribe();
  }

  onCancel(): void {
      this.completed.emit('cancelled')
  }

  step1(): void {
      if(this.existingContactCount > 0 && this.migrationForm && this.details && this.next === 'migrate') {
          const targetContactType = this.migrationForm.get('targetContactType')?.value;
          if (targetContactType) {
              this.isLoading = true;
              this.contactTypeService.migrateContactTypeContacts(this.details.id, targetContactType).subscribe(res => {
                  this.isLoading = false;
                  this.migrationSuccess = res.success ?? false;
                  this.migrationSuccessMessage = res.message ?? '';
                  if (res.success) {
                      this.next = 'complete';
                      this.step = 2;
                  }
              });
          }
      } else if (this.existingContactCount < 1 && this.details && this.next === 'complete') {
          this.handleArchiving();
      }
  }

  step2(): void {
      this.handleArchiving();
  }

  step3(): void {
    this.completed.emit('completed');
  }

  private handleArchiving() {
      if (this.details && this.details.id) {
          this.contactTypeService.archiveContactType(this.details.id).subscribe(res => {
              this.archiveSuccess = res.success;
              this.archiveSuccessMessage = res.message ?? '';
              if (res.success) {
                  this.step = 3;
              }
          })
      }
  }

} // EOC
